import type { Example } from '../types';

export const visibilityExpressionsExample: Example = {
  id: 'visibility-expressions',
  title: 'Conditional Parameters',
  categoryId: 'parameters',
  description: 'Parameters that show/hide based on other values',
  scadCode: `/* Conditional Parameters */

// markdown:tip
// **Conditional Parameters** — Append \`{expression}\` to any parameter comment
// to show or hide it based on other values. Entire tab groups can appear and
// disappear too. Toggle **Add Lid** and **Add Label** to see it in action.

/* [Base] */

// Shape
shape = "box"; // [box, cylinder]

// Width (box only)
width = 60; // [20:1:120] {shape == "box"}

// Depth (box only)
depth = 40; // [20:1:120] {shape == "box"}

// Diameter (cylinder only)
diameter = 50; // [20:1:100] {shape == "cylinder"}

// Height
height = 35; // [10:1:80]

// Wall thickness
wall = 3; // [1:0.5:8]

// Add a lid?
add_lid = true;

// Add a label?
add_label = true;

/* [Lid] {add_lid == true} */

// Lid height
lid_height = 8; // [3:0.5:20]

// Lid color
// color
lid_color = [0.85, 0.3, 0.2];

/* [Label] {add_label == true} */

// Label text
label_text = "MESHPIT";

// Font size
font_size = 7; // [3:0.5:14]

// Depth of engraving
engrave_depth = 1.2; // [0.3:0.1:3]

// --- parameters end ---

is_box = (shape == "box");
w = is_box ? width  : diameter;
d = is_box ? depth  : diameter;

module outer() {
  if (is_box) cube([w, d, height], center=true);
  else        cylinder(d=diameter, h=height, center=true);
}

module inner() {
  iw = w - wall*2; id_ = d - wall*2;
  if (is_box) translate([0,0,wall]) cube([iw, id_, height], center=true);
  else        translate([0,0,wall]) cylinder(d=diameter - wall*2, h=height, center=true);
}

// Body
color([0.3, 0.55, 0.8])
difference() {
  outer();
  inner();
}

// Lid
if (add_lid) {
  color(lid_color)
  translate([0, 0, height/2 + lid_height/2 + 0.5])
  if (is_box) cube([w - 0.4, d - 0.4, lid_height], center=true);
  else        cylinder(d=diameter - 0.4, h=lid_height, center=true);
}

// Label
if (add_label && shape == "box") {
  color([1, 1, 1])
  translate([0, -d/2 + 0.5, 0])
  rotate([-90, 0, 0])
  linear_extrude(engrave_depth)
  text(label_text, font="Liberation Sans:style=Bold",
       size=font_size, halign="center", valign="center");
}
`,
};
